import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function GuaranteeSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-92">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-93">
        <div className="bg-navy-dark p-8 md:p-12 rounded-2xl border-2 border-gold-primary/40 shadow-lg text-center" data-id="element-94">
          <div className="flex justify-center mb-6" data-id="element-95">
            <div className="bg-gold-primary/10 p-4 rounded-full border border-gold-primary/30" data-id="element-96">
              <ShieldCheckIcon className="w-12 h-12 text-gold-primary" data-id="element-97" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-heading font-bold text-gold-primary mb-8" data-id="element-98">
            Garantía Total de Valor
          </h2>

          <div className="space-y-4 text-xl md:text-2xl text-gray-200 leading-relaxed" data-id="element-99">
            <p data-id="element-100">
              Si lees este eBook y sientes que no aprendiste nada nuevo que
              pueda impactar tu próxima declaración...
            </p>

            <p className="font-bold text-white" data-id="element-101">
              Dímelo y te devuelvo cada centavo.
            </p>

            <p className="text-gray-400" data-id="element-102">
              Sin preguntas. Sin formularios. Sin drama.
            </p>

            <p className="text-gold-primary font-bold text-2xl md:text-3xl font-heading pt-4" data-id="element-103">
              El riesgo es mío. La ganancia es tuya.
            </p>
          </div>
        </div>
      </div>
    </section>;
}